import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinOrDash',
  standalone: true,
})
export class JoinOrDashPipe implements PipeTransform {
  transform(
    value: readonly string[] | null | undefined,
    separator = ', ',
    empty = '—',
  ): string {
    if (!value?.length) {
      return empty;
    }
    return value.join(separator);
  }
}
